import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { cycleThoughts } from '../data/painPoints';
export function ProblemSection() {
  return <section className="w-full bg-cream-100 py-14 sm:py-20" data-id="element-273" data-mp="30hzguz34vqkb">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-274" data-mp="2vqr53webzt3z">
        <SectionHeading title={<>
              What if the problem{' '}
              <em className="not-italic text-gold-600" data-id="element-276" data-mp="39jyyntlz2yob">
                isn’t where the paper marks?
              </em>
            </>} data-id="element-275" data-mp="2voefqy68uggw" />

        <div className="mt-9 rounded-3xl border border-navy-900/10 bg-white p-5 shadow-card sm:p-7" data-id="element-277" data-mp="3jgbpmjq4uyfd">
          <p className="text-[14px] font-semibold uppercase tracking-wide text-navy-700/60" data-id="element-278" data-mp="3ei0hqejeexzs">
            Every time a patient says:
          </p>
          <blockquote className="mt-3 border-l-4 border-gold-500 pl-4 font-display text-[21px] font-bold italic leading-snug text-navy-900 sm:text-2xl" data-id="element-279" data-mp="1p457f0ytnhdk">
            “Doctor, something still feels off when I bite…”
          </blockquote>
          <p className="mt-3 text-[15px] font-medium text-navy-700/80" data-id="element-280" data-mp="obooyqqx91hg">
            the same cycle can begin.
          </p>

          <ul className="mt-6 space-y-2.5" data-id="element-281" data-mp="sd05m6rticdi">
            {cycleThoughts.map(thought => <li key={thought} className="flex items-start gap-3 rounded-2xl bg-cream-200/70 p-3.5" data-id="element-282" data-mp="x5js5t8hghug">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-clinical-red/10 text-clinical-red" aria-hidden="true" data-id="element-283" data-mp="125z9evvvy9hp">
                  <XIcon className="h-3.5 w-3.5" data-id="element-284" data-mp="1g346w7hja01c" />
                </span>
                <span className="text-[14.5px] font-medium leading-snug text-navy-800 sm:text-[15px]" data-id="element-285" data-mp="1g19vbjs5jk9x">
                  {thought}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mt-8 rounded-3xl bg-navy-900 p-6 text-center sm:p-8" data-id="element-286" data-mp="p0919s2s1af2">
          <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-287" data-mp="p2d2u3d7dxc6">
            And this is where the real problem begins
          </p>
          <p className="mt-4 font-display text-[22px] font-bold leading-tight text-cream-100 sm:text-3xl" data-id="element-288" data-mp="y204mq9uh55r">
            You may not need more marks.
          </p>
          <p className="mt-2 font-display text-[22px] font-bold leading-tight text-gold-400 sm:text-3xl" data-id="element-289" data-mp="17z4scujc98oo">
            You may need a better sequence of analysis.
          </p>
        </div>

        <div className="mx-auto mt-8 w-full max-w-md" data-id="element-290" data-mp="12y7bcla2ekor">
          <CTAButton label="I want the Occlusion 360™ system" subline="Instant access · One-time payment · No monthly fees" data-id="element-291" data-mp="1hnmqt545b3p5" />
        </div>
      </div>
    </section>;
}